const Link = {
  functional: true,
  render: (h, ctx) => {
    const { text, disabled, tag } = ctx.props;
    return h(tag || 'div', [
      h(
        'span',
        {
          style: {
            color: disabled ? '#848484' : '#409EFF',
            textDecoration: disabled ? 'none' : 'underline',
            cursor: disabled ? 'no-drop' : 'pointer',
            userSelect: 'none'
          },
          on: disabled ? {} : { ...ctx.listeners }
        },
        text || '-'
      )
    ]);
  }
};
export default Link;
